<div class="team-leaders-container py-12">
    <div fxLayoutAlign="space-between center" class="mb-8">
        <h2 class="my-16 font-normal text-lg">{{ 'TEAMS.LEAD.TITLE' | translate }} ({{ (teamService.teamLeaders$ | async).length }})</h2>

        <app-white-button
            [icon]="'add'"
            [label]="'TEAMS.LEAD.BUTTON.ADD_LEAD'"
            (onClick)="openAddDialog()"
            *ngIf="(teamService.teamLeaders$ | async).length && canManageTeamLeaders"
        ></app-white-button>
    </div>

    <div class="team-leaders">
        <div
            fxLayout="row wrap"
            fxLayoutAlign="flex-start space-between"
            fxLayoutGap.gt-xs="8px grid"
            class="pb-8"
            *ngIf="(teamService.teamLeaders$ | async).length; else noLeaders"
        >
            <mat-card
                appearance="outlined"
                fxLayout="row"
                fxLayoutAlign="flex-start space-between"
                fxFlex="1 0 calc(100%-8px)"
                fxFlex.gt-xs="1 0 calc(50%-8px)"
                fxFlex.gt-md="1 0 calc(33.33%-8px)"
                class="mb-12 p-0 pr-48 relative team-leader-card-container user-details-card-container mat-elevation-z0"
                *ngFor="let teamLeader of teamService.teamLeaders$ | async"
            >
                <div #userAvatar class="pointer">
                    <img class="user-avatar mr-4" *ngIf="teamLeader.avatar.src; else initials" [alt]="teamLeader.fullName" [src]="teamLeader.avatar.src" />
                    <ng-template #initials>
                        <div fxLayoutAlign="center center" class="avatar-initials user-avatar">{{ teamLeader.fullName | initials }}</div>
                    </ng-template>
                </div>
                <app-user-details-card [user]="teamLeader" [target]="userAvatar" openedFrom="team_admin_space"></app-user-details-card>

                <mat-card-content class="p-12">
                    <h3 class="m-0 font-normal">{{ teamLeader.fullName }}</h3>

                    <button class="more-menu" mat-icon-button [matMenuTriggerFor]="moreMenu" aria-label="More" (click)="$event.stopPropagation()" *ngIf="canManageTeamLeaders">
                        <mat-icon class="mat-icon-more-vert">more_vert</mat-icon>
                    </button>

                    <mat-menu #moreMenu="matMenu" xPosition="before">
                        <button mat-menu-item aria-label="remove" (click)="openRemoveTeamLeaderDialog(teamLeader)">
                            <mat-icon>delete</mat-icon>
                            <span>{{ 'GENERAL.BUTTON.REMOVE' | translate }}</span>
                        </button>
                    </mat-menu>
                </mat-card-content>
            </mat-card>
        </div>

        <ng-template #noLeaders>
            <div fxLayout="column" fxLayoutAlign="center center" class="no-team-leaders-container py-48 px-24 bg-white">
                <mat-icon class="participant-view-illustration" svgIcon="members_illustration"> </mat-icon>
                <h3 class="mt-8 mb-16">
                    {{ 'TEAMS.LEAD.LABEL.NO_LEAD_YET' | translate }}
                </h3>

                <app-flat-button [icon]="'add'" [label]="'TEAMS.LEAD.BUTTON.ADD_LEAD'" (onClick)="openAddDialog()" *ngIf="canManageTeamLeaders"></app-flat-button>
            </div>
        </ng-template>
    </div>
</div>
